// extracted by mini-css-extract-plugin
export default {"tabs":"search_tabs-module___tabs___d80214b1"};